"use client";
import { useQuery } from "@tanstack/react-query";
import { getClients } from "@/lib/actions/admin-dashboard/clients/get/getClients";

export const useGetClients = () => {
  return useQuery({
    queryKey: ["clients"],
    queryFn: getClients,
  });
};